import { useEffect, useRef, useState } from 'react';
import useStakeholderNotesFunctions from 'components/Dashboard/StakeHolders/StakeholderPage/useStakeholderNotesFunctions';
import useStakeholderEmailsFunctions from 'components/Dashboard/StakeHolders/StakeholderPage/useStakeholderEmailsFunctions';
import stakeholderIncludesStaffEmails from 'components/Dashboard/StakeHolders/StakeholderPage/stakeholderIncludesStaffEmails';

const MIN_REVEAL_DELAY_MS = 1000;
const useStakeholderBioTabCounts = ({ StakeholderInformation, enabled }) => {
  const { objectId, id, groups, categories, email } = StakeholderInformation ?? {};

  const notesFunctions = useStakeholderNotesFunctions();
  const emailsFunctions = useStakeholderEmailsFunctions();
  const { userNotes, getNotes } = notesFunctions;
  const { emails, getEmails } = emailsFunctions;

  const initialCall = useRef(null);
  initialCall.current = (source) => {
    if (!enabled) return;
    getNotes({ objectId, requestSource: source, contentType: 'Stakeholder' });
    getEmails({ id, requestSource: source, includeSentToStaff: stakeholderIncludesStaffEmails({ email, categories }) });
  };

  useEffect(() => {
    const source = new AbortController();
    initialCall.current(source);
    return () => {
      source.abort('Api call cancelled by the user');
    };
  }, [enabled]);

  const dataLoaded = !enabled || (!notesFunctions.isLoading && !emailsFunctions.isLoading);
  const [minDelayElapsed, setMinDelayElapsed] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setMinDelayElapsed(true), MIN_REVEAL_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return {
    notesFunctions,
    emailsFunctions,
    notesCount: userNotes?.length ?? 0,
    emailsCount: emails?.filter((item) => item.status === 'Sent').length ?? 0,
    groupsCount: groups?.length ?? 0,
    countsReady: dataLoaded && minDelayElapsed,
  };
};

export default useStakeholderBioTabCounts;
